import { verificaAcesso } from '@/routesAccess'
import Pendente from '@/views/DePara/Franqueador/FranqueadorPendente'
import Revisao from '@/views/DePara/Franqueador/FranqueadorRevisao'
import Aprovado from '@/views/DePara/Franqueador/FranqueadorAprovado'

const routerName = 'Franqueador'

export const Franqueador =  [
  {
    path: `pendente/:customerId`,
    name: 'de-para-franqueador-pendente',
    component: Pendente,
    beforeEnter: verificaAcesso,
    props: true,
    meta: { requiresAuth: true, rule: 'DePara', contexto: 'pendente' }
  },
  {
    path: `revisao/:customerId`,
    name: 'de-para-franqueador-revisao',
    component: Revisao,
    beforeEnter: verificaAcesso,
    props: true,
    meta: { requiresAuth: true, rule: 'DePara', contexto: 'revisao' }
  },
  {
    path: `aprovado/:customerId`,
    name: 'de-para-franqueador-aprovado',
    component: Aprovado,
    beforeEnter: verificaAcesso,
    props: true,
    meta: { requiresAuth: true, rule: 'DePara', contexto: 'aprovado' }
  },
]

